import { getComponentContentById } from "@cappelendamm/crystallize-utils";
import { CRYSTALLIZE_IDS } from "../../crystallize-constants.js";
import { isSubscriptionShapeBookClub } from "../../subscription-plan/selectors/isSubscriptionShape.js";
/**
 * The name members know a book club by. One club can be split into several
 * products (Barnas Bokverden has one per age group, Leseløve one per level),
 * and they all share the club code, so its name is used instead of the
 * product name. Falls back to the product name when no club code is set.
 *
 * Returns undefined for products that are not book clubs. Series and book
 * subscriptions have a club code too, but it is not their name (Lesepause
 * Krim's is "Cappelen Damm Abonnement").
 */
export const getSubscriptionClubName = (subscription) => {
    const shape = subscription.product.shape?.identifier;
    if (!shape || !isSubscriptionShapeBookClub(shape))
        return undefined;
    const clubCode = getComponentContentById(subscription.product.components, CRYSTALLIZE_IDS.SHAPE.PRODUCT.BOOK_CLUB.CLUB_CODE)?.options?.[0];
    return (clubCode?.key?.trim() || subscription.product.name?.trim() || undefined);
};
